// extracted by mini-css-extract-plugin
export default {"modal__button":"bbc4a0","sub-title":"c52e57","child-list":"af3c22","child-list__item":"cc8cb0","list":"fa0847","list__item":"ca014e"};